import React from "react"

// Material UI
import { makeStyles } from "@material-ui/core/styles"
import { CircularProgress, Button, ButtonProps } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
  root: {
    textTransform: "none",
    fontSize: theme.typography.body1.fontSize,
    boxShadow: ({ color, variant, disableElevation }: Props) =>
      !disableElevation && color === "primary" && variant === "contained"
        ? // @ts-expect-error change this approach as app
          theme.shadows[25]
        : "inherit"
  }
}))
type Props = {
  loading?: boolean
  children?: React.ReactNode
  color?: "inherit" | "default" | "primary" | "secondary" | "error" | undefined
  variant?: "text" | "contained" | "outlined" | undefined
  className?: string
  disabled?: boolean
  fullWidth?: boolean
  type?: "button" | "reset" | "submit" | undefined
  component?: any
  to?: string
  disableElevation?: boolean
  arrow?: boolean
} & ButtonProps

const CustomButton = React.forwardRef<HTMLInputElement, Props>(
  ({ loading, color, variant, disabled, disableElevation, ...props }, ref) => {
    const classes = useStyles({
      color,
      variant,
      disableElevation
    })

    return (
      // @ts-expect-error This is required due to improper ref type
      <Button
        ref={ref}
        classes={{
          root: classes.root
        }}
        color={color}
        variant={variant}
        disableElevation={disableElevation}
        disabled={loading || disabled}
        {...props}
      >
        {props.children}
        {loading && (
          <CircularProgress
            color="inherit"
            size={20}
            style={{ marginLeft: 8 }}
          />
        )}
      </Button>
    )
  }
)

CustomButton.defaultProps = {
  loading: false
}

export default CustomButton
